import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './pendingApprovalAdviserProfilesContainerActions'

const initialState = {
  fetchingPendingApprovalProfiles: false,
  pendingApprovalAdviserProfiles: [],
  searchTerm: '',
  filter: 'pendingApproval',
  filterChange: false,
  currentPage: 1,
  currentPageChange: false,
  pageSize: 15,
  totalProfilesPendingApproval: 0,
  numPages: 0
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  switch (action.type) {
    case events.fetching.pendingApprovalProfiles:
      newState.filterChange = false
      newState.currentPageChange = false
      newState.fetchingPendingApprovalProfiles = true
      return newState
    case events.fetched.pendingApprovalProfiles:
      newState.fetchingPendingApprovalProfiles = false
      var allProfiles = Array.isArray(action.payload) ? action.payload : []
      newState.pendingApprovalAdviserProfiles = allProfiles
      if (allProfiles && allProfiles.length > 0) {
        var totalProfiles = allProfiles[0].totalProfiles
        newState.totalProfilesPendingApproval = totalProfiles
        newState.numPages = Math.ceil(totalProfiles / newState.pageSize)
      } else {
        newState.numPages = 0
        newState.totalProfilesPendingApproval = 0
      }
      return newState
    case events.set.searchTerm:
      newState.searchTerm = action.searchTerm
      return newState
    case events.set.filter:
      newState.filterChange = true
      newState.filter = action.filter
      newState.currentPage = 1
      return newState
    case events.set.page:
      newState.currentPage = action.page
      newState.currentPageChange = true
      return newState
  }
  return state
}
